export default __webpack_public_path__ + "static/media/Landing.6e79fc20.jpg";